import { render } from "./block-with-custom-products.vue?vue&type=template&id=5403bab0&scoped=true"
import script from "./block-with-custom-products.vue?vue&type=script&lang=js"
export * from "./block-with-custom-products.vue?vue&type=script&lang=js"

import "./block-with-custom-products.vue?vue&type=style&index=0&id=5403bab0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5403bab0"]])

export default __exports__